import { fetchWithAuth } from "../util/fetch-utils";
export default class VelavuAPIAuthorizeMQTT {
    // This method creates a policy document restricting access to MQTT topics of the given organization,
    // and attaches that policy to the user's cognito federated identity. This allows an authenticated user
    // to use pubsub functionality for real-time location and alert updates.
    async authorizeMQTT(identityID) {
        await fetchWithAuth(`/mqttauth/${identityID}`, {
            method: "PUT",
        });
    }
}
//# sourceMappingURL=velavu-api-authorize-mqtt.js.map